var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"subfolder create-folder"},[_c('v-icon',{staticClass:"subfolder__icon"},[_vm._v("create_new_folder")]),_c('p',{staticClass:"subfolder__name"},[_vm._v("New Folder")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }